import React, { useEffect, useState, createContext, useContext } from 'react';
import { translations, Language } from '../utils/translations';
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: typeof translations.es;
  hasSelectedLanguage: boolean;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [language, setLanguageState] = useState<Language>('es');
  const [hasSelectedLanguage, setHasSelectedLanguage] = useState(false);
  useEffect(() => {
    const selected = localStorage.getItem('languageSelected');
    if (selected) {
      setHasSelectedLanguage(true);
      const savedLang = localStorage.getItem('language') as Language;
      if (savedLang) {
        setLanguageState(savedLang);
      }
    }
  }, []);
  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    setHasSelectedLanguage(true);
    localStorage.setItem('language', lang);
    localStorage.setItem('languageSelected', 'true');
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t: translations[language],
    hasSelectedLanguage
  }} data-id="element-105">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}